import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PodcastForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // message text
  const [submitStatusType, setSubmitStatusType] = useState(null); // 'success' or 'danger'
  const [errors, setErrors] = useState({});

const boxStyle = {
        width: '100%',
        // maxWidth: '400px',
        padding: '20px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus(null);
    setSubmitStatusType(null);
    setErrors({});

    // Build form data object from form inputs
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Because your controller expects booleans for agreements,
    // convert "Yes, I Agree" strings or checkboxes to boolean true
    data.media_presence_agreement = data.q3 === "Yes, I Agree";
    data.share_raw_footage_agreement = data.q2 === "Yes, I Agree";
    data.final_approval_agreement = data.q1 === "Yes, I Agree";

    // Also handle request_speaker as string or array (checkboxes)
    if (Array.isArray(data.request_speaker)) {
      data.request_speaker = data.request_speaker.join(", ");
    }

    try {
      const response = await fetch(`${API_BASE_URL}/podcast-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        // Validation errors or other errors
        if (result.errors) {
          setErrors(result.errors);
          setSubmitStatus('Please fix the errors below and try again.');
          setSubmitStatusType('danger');
        } else {
          setSubmitStatus(result.message || 'Submission failed.');
          setSubmitStatusType('danger');
        }
      } else {
        setSubmitStatus(result.message || 'Submitted successfully!');
        setSubmitStatusType('success');
        setErrors({});
        e.target.reset();
      }
    } catch (error) {
      setSubmitStatus('Network or server error. Please try again.');
      setSubmitStatusType('danger');
    } finally {
      setLoading(false);
    }
  };

  // Helper to check if a field has error (API returns array of errors per field)
  const hasError = (field) => errors && errors[field] && errors[field].length > 0;

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="p-4">
            <h2 className="text-center mb-4">Podcast Requests</h2>

            

            <Form className="px-5" style={boxStyle} onSubmit={handleSubmit} noValidate>
              {/* Podcast Name */}
              <Form.Group className="mb-3" controlId="podcast_name">
                <Form.Label>Podcast Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="podcast_name"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('podcast_name')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('podcast_name') && errors.podcast_name[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Full Name */}
              <Form.Group className="mb-3" controlId="full_name">
                <Form.Label>Full Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="full_name"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('full_name')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('full_name') && errors.full_name[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Phone Number */}
              <Form.Group className="mb-3" controlId="phone_number">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control
                  type="phone"
                  name="phone_number"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('phone_number')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('phone_number') && errors.phone_number[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Whatsapp Number */}
              <Form.Group className="mb-3" controlId="whatsapp_number">
                <Form.Label>Whatsapp Number *</Form.Label>
                <Form.Control
                  type="phone"
                  name="whatsapp_number"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('whatsapp_number')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('whatsapp_number') && errors.whatsapp_number[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Email */}
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('email')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('email') && errors.email[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Website URL */}
              <Form.Group className="mb-3" controlId="website_url">
                <Form.Label>Website URL *</Form.Label>
                <Form.Control
                  type="text"
                  name="website_url"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('website_url')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('website_url') && errors.website_url[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Social Media Links */}
              <Form.Group className="mb-3" controlId="social_media_links">
                <Form.Label>Social Media Links *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="social_media_links"
                  style={{ height: '100px', backgroundColor: 'transparent' }}
                  isInvalid={hasError('social_media_links')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('social_media_links') && errors.social_media_links[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Podcast Description */}
              <Form.Group className="mb-3" controlId="podcast_description">
                <Form.Label>Podcast Description/Overview *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="podcast_description"
                  style={{ height: '100px', backgroundColor: 'transparent' }}
                  isInvalid={hasError('podcast_description')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('podcast_description') && errors.podcast_description[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Who are you requesting to speak? */}
              <Form.Group className="mb-3">
                <Form.Label>Who are you requesting to speak? *</Form.Label>
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Jahid Hasan"
                    id="speak-jahid"
                    name="request_speaker"
                    value="Jahid Hasan"
                    isInvalid={hasError('request_speaker')}
                  />
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('request_speaker') && errors.request_speaker[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Interview mode */}
              <Form.Group className="mb-3">
                <Form.Label>Will this interview be virtual or in-person? *</Form.Label>
                <div>
                  {["Virtually", "In-person"].map((option, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="interview_mode"
                      label={option}
                      id={`mode-${index}`}
                      value={option}
                      isInvalid={hasError('interview_mode')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('interview_mode') && errors.interview_mode[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Why do you want them as a guest? */}
              <Form.Group className="mb-3" controlId="reason_for_guest">
                <Form.Label>Why do you want them as a guest? *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="reason_for_guest"
                  style={{ height: '100px', backgroundColor: 'transparent' }}
                  isInvalid={hasError('reason_for_guest')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('reason_for_guest') && errors.reason_for_guest[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Interview Length */}
              <Form.Group className="mb-3" controlId="interview_length">
                <Form.Label>Interview Length *</Form.Label>
                <Form.Control
                  type="text"
                  name="interview_length"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('interview_length')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('interview_length') && errors.interview_length[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Talking Points */}
              <Form.Group className="mb-3" controlId="talking_points">
                <Form.Label>Talking Points *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="talking_points"
                  required
                  style={{ height: '200px', backgroundColor: 'transparent' }}
                  isInvalid={hasError('talking_points')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('talking_points') && errors.talking_points[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Average Views/Downloads */}
              <Form.Group className="mb-3">
                <Form.Label>Average Views/Downloads (Last 3 episodes) *</Form.Label>
                <div>
                  {["0-100", "100-500", "500-2000", "2000-5000", "5000-10000", "10000+"].map((range, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="average_views"
                      label={range}
                      id={`views-${index}`}
                      value={range}
                      isInvalid={hasError('average_views')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('average_views') && errors.average_views[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Agreement q3 */}
              <Form.Group className="mb-3">
                <Form.Label>Do you agree that passionateworlduniversity.com can have media presence during the podcast and permission to use footage on Jahid Hasan's social media accounts?*</Form.Label>
                <div>
                  {["Yes, I Agree"].map((option, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="media_presence_agreement"
                      label={option}
                      id={`q3-${index}`}
                      value={option}
                      isInvalid={hasError('media_presence_agreement')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('media_presence_agreement') && errors.media_presence_agreement[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Agreement q2 */}
              <Form.Group className="mb-3">
                <Form.Label>Do you agree to share the raw footage from the podcast recording with our team after the podcast is complete and give permission for us to use footage on Jahid Hasan's social media accounts?*</Form.Label>
                <div>
                  {["Yes, I Agree"].map((option, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="share_raw_footage_agreement"
                      label={option}
                      id={`q2-${index}`}
                      value={option}
                      isInvalid={hasError('share_raw_footage_agreement')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('share_raw_footage_agreement') && errors.share_raw_footage_agreement[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Agreement q1 */}
              <Form.Group className="mb-3">
                <Form.Label>We require that we must have final approval of all content (pre & post podcast interview materials) that has Jahid Hasan's name, image, and likeness attached to it. Do you agree?*</Form.Label>
                <div>
                  {["Yes, I Agree"].map((option, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="final_approval_agreement"
                      label={option}
                      id={`q1-${index}`}
                      value={option}
                      isInvalid={hasError('final_approval_agreement')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('final_approval_agreement') && errors.final_approval_agreement[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <div className="text-center mt-5 mb-5">
                <Button className="btn-default" variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{' '}
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </Button>
              </div>
            </Form>
            {submitStatus && (
              <Alert variant={submitStatusType}>
                {submitStatus}
              </Alert>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PodcastForm;
